












import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class VIconButton extends Vue {
  @Prop({ required: true }) readonly iconName!: string;
  @Prop({ default: 'white' }) readonly iconColor!: string;

  get iconColorClass(): string {
    return `text-${this.iconColor}`;
  }
}
